import getLanguageByPath from '@src/utils/locale/getLanguageByPath.js';
import constants from '@src/constants/index.js';
// import qs from '@xfe-team/utils/src/query-string-util.js';
import Config from '@src/global-locales/config.js';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName.js';

const langJsonMapper = Config.langJsonMapper;

function setHtmlLang(lang) {
  const defaultLang = document.getElementsByTagName('html')[0].getAttribute('lang');
  const root = document.documentElement;
  if (!defaultLang) {
    document.getElementsByTagName('html')[0].setAttribute('lang', getLanguageFolderName() || 'en');
    root.style.setProperty('--lang', lang || 'en');
  }
}

const LOCALE_DATA = Config.LOCALE_DATA;

export default async function localesInit(language) {
  const lang = language || getLanguageByPath();
  setHtmlLang(lang);

  window['$$XFE_LOCALES'] = {};

  if (!constants.IS_MASTER && window.location.search.indexOf('__LOCALE_DEBUG__') > -1) {
    // const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    // const debugLang = searchParams?.__LOCALE_DEBUG__ || 'en';
    // if (!langJsonMapper[debugLang]) {
    //   throw new Error('__LOCALE_DEBUG__找不到该语言');
    // }
    // const localeData = await import(`@src/global-locales/build/debug/${lang ? langJsonMapper[debugLang] : ''}.json`);
    // window['$$XFE_LOCALES'] = localeData.default;
    // return;
  }
  const localeData = await LOCALE_DATA[lang]();
  window['$$XFE_LOCALES'] = localeData.default || {};
}
